export const PERMISSIONS = {
  VIEW_BUYOUTS_PERMISSION: "can_view_buyouts",
  VIEW_BONUSES_PERMISSION: "can_view_bonuses",
  VIEW_BLACKLIST_PERMISSION: "can_view_blacklist",
  VIEW_BUYOUT_LOGS_PERMISSION: "can_view_buyout_logs",
  VIEW_PAYMENTS_PERMISSION: "can_view_payments",
  VIEW_CHATS_PERMISSION: "can_view_chats",
  VIEW_DELIVERY_NOTES_PERMISSION: "can_view_delivery_notes",
  VIEW_EXPORTS_PERMISSION: "can_view_exports",
  VIEW_TOOLS_PERMISSION: "can_view_tools",
  VIEW_BUSINESS_CASES_PERMISSION: "can_view_business_cases",
  VIEW_BUSINESS_CASE_ISSUES_PERMISSION: "can_view_business_case_issues",
  VIEW_BUSINESS_CASE_INVOICES_PERMISSION: "can_view_business_case_invoices",
  VIEW_LEASING_PRODUCTS_PERMISSION: "can_view_leasing_products",
  VIEW_LEASING_CURVES_PERMISSION: "can_view_leasing_curves",
  VIEW_STOCK_MOVES_PERMISSION: "can_view_stock_moves",
  VIEW_ALL_STORE_BUYOUTS_PERMISSION: "can_view_all_store_buyouts",
  VIEW_ALL_PARTNER_BUYOUTS_PERMISSION: "can_view_all_partner_buyouts",
  VIEW_PROFILE_DASHBOARD: "can_view_profile_dashboard",
  VIEW_PROFILE_NOTIFICATIONS: "can_view_profile_notifications",
  VIEW_PROFILE_MESSAGES: "can_view_profile_messages",
  VIEW_PROFILE_HANDOVER_DEVICES: "can_view_profile_handover_devices",
  VIEW_PROFILE_DELIVERY_NOTES: "can_view_profile_delivery_notes",
  VIEW_PROFILE_REWARDS: "can_view_profile_rewards",
  VIEW_PROFILE_PERSONAL_INFO: "can_view_profile_personal_info",
  VIEW_PROFILE_MY_BUYOUTS: "can_view_profile_my_buyouts",
  VIEW_PROFILE_TARIFF_LIST: "can_view_profile_tariff_list",
  VIEW_PROFILE_BONUSES: "can_view_profile_bonuses",
  VIEW_PROFILE_EDUCATION: "can_view_profile_education",
  VIEW_PROFILE_EXPORTS: "can_view_profile_exports",
  VIEW_PROFILE_AMBASSADORS: "can_view_profile_ambassadors",
  VIEW_PROFILE_COMPANY_DATA: "can_view_profile_company_data",
  VIEW_PROFILE_API: "can_view_profile_api",
} as const;

export function usePermissions() {
  return PERMISSIONS;
}
